<template lang="pug">
div.advice-table-container
  slot(name="reasontype")
    span.floatr.advice-tip 采纳以下
        i.red  {{adviceSuggestNum}}
        |  个建议预计展现量提升
        i.red  {{adviceEstiAddAdpv}}
        | ，点击量提升
        i.red  {{adviceEstiAddAdclick}}

  .advice-table
    HeadFixedTable(
      classname="opt-table visible-table-td",
      :columns="currentColumns",
      :checkbox="hasCheckbox",
      :check_all="hasCheckbox",
      :checkbox_length="1000",
      :isAllChecked= "isAllChecked",
      :hasPagination = "true",
      @pageChange = "pageChange",
      :list = "currentList"
      )
      template(slot="submit_planTime-td" scope="props")
        span {{props.item.submit_planTime | suggestTime}} 
        span.btn.btn-icon(@click.stop="openTimePicker(props.item)" v-show="isEditable && !props.item.status")
          i.fa.fa-edit
        span.service-timepicker(v-show="props.item.suggestTimeEdit", @click.stop="stop")
          .timepicker-panel
            i.triangle
            Timepicker(
              :timearrstring = "reformTimeString(props.item.submit_planTime)",
              @confirm="updatePlanTime",
              @cancel="closeTimePicker(props.item)")

      template(slot="delete-td" scope="props")
          slot(name="delete", :item="props.item")
      template(slot="status-td" scope="props")
          slot(name="status", :item="props.item")

</template>
<script>
import HeadFixedTable from '../../component/fold-table.vue'
import Timepicker from '../../component/timepicker.vue'
import Mixin from '../mixin.js'

const unusedFlag = '0'
export default {
  mixins: [Mixin],
  props: {
    hasCheckbox: {
      type: Boolean,
      default: true
    },
    isAllChecked: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    extendColumns: {
      type: Array,
      default() {
        return  []
      }
    },
    list: {
      type: Array, 
      default(){ 
        return [{
          "plan": "测试",
          "planId": 111,
          "planTime": {1:"0,0,0,0,0,1,1,1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0",2:"0,0,0,0,2,0,2,0,2,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0",3:"0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0",4:"0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0",5:"0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0",6:"0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0",7:"0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0"}, //1表示已占用，0表示未占用
          "reason": "ceshi",
          "esti_add_adpv": 123,
          "esti_add_adclick": 111,
          "esti_add_tnum": 342
        }]
      }
    }
  },
  components: {
    HeadFixedTable,
    Timepicker
  },
  data() {
    return {
      columns: [{
        title: "推广计划",
        key: "plan"
      },{
        title: "当前投放时间",
        key: "planTime",
        render(index, value, item) {
          const suggestFlag = '2'
          let str = ""
          for(let key in Object.keys(value)){
            str +=  ';' + value[key]
          }
          return str.includes(unusedFlag) || str.includes(suggestFlag) ? '部分时间段' : '全部时间段'
        }
      },{
        title: "推荐投放时间",
        key: "submit_planTime",
        render(index, value, item) {
          return ''
        }
      }],
    }
  },
  computed: {
    //勾选建议数量
    adviceSuggestNum() {
      return this.$store.state.tableCheckList.length
    },
    adviceEstiAddAdpv() {
      let result = 0
      _.map(this.$store.state.tableCheckList, (item) => {
        result += +item.esti_add_adpv
      })
      return result
    },
    adviceEstiAddAdclick() {
      let result = 0
      _.map(this.$store.state.tableCheckList, (item) => {
        result += +item.esti_add_adclick
      })
      return result
    },
    currentColumns() {
      return _.concat(this.columns, this.extendColumns)
    },
    currentList() { 
      return _.map(_.cloneDeep(this.list), item => {
        this.$set(item, 'checked', false)
        this.$set(item, 'suggestTimeEdit', false)
        !_.has(item, 'submit_planTime') &&this.$set(item, 'submit_planTime', item.planTime)
        return item
      })
    }

  },
  filters: {
    suggestTime(time) {
      let str = ""
      for(let key of Object.keys(time)){
        str +=  ';' + time[key]
      }
      console.log(str.includes(unusedFlag))
      return str.includes(unusedFlag) ? '部分时间段' : '全部时间段'
    },
  },
  mounted() {
    document.addEventListener('click', this.closeEditPanel);
  },
  destroyed() {
    document.removeEventListener('click', this.closeEditPanel);
  },
  methods: {
    stop() {},
    pageChange(list) {
      this.$emit('pageChange', list)
    },
    closeEditPanel() {
      let editTimeObj = _.find(this.currentList, item => item.suggestTimeEdit)
      !_.isEmpty(editTimeObj) && this.closeTimePicker(editTimeObj)
    },
    openTimePicker(item) {
      if(item.suggestTimeEdit) return
      let editTimeObj = _.find(this.currentList, item => item.suggestTimeEdit)
      if(_.isEmpty(editTimeObj)) {
        this.pushItemIntoCheckList(item)
        this.$set(item, 'suggestTimeEdit', true)
      } else {
        this.closeTimePicker(editTimeObj)
      }
    },
    closeTimePicker(item) {
      //this.$set(item, 'submit_planTime', item.planTime)
      this.$set(item, 'suggestTimeEdit', false)
      console.log('close')
    },
    updatePlanTime(times) {
      console.log(times)
      let item = _.find(this.currentList, {suggestTimeEdit: true})
      let planTime = {}
      times.map((time,index) => {
        let timeItem = time.join(',')
        planTime[index+1] = timeItem
      })
      console.log(planTime)
      this.$set(item, 'submit_planTime', planTime)
      this.$set(item, 'suggestTimeEdit', false)
    },
    reformTimeString(time) {
      let timeArr = []
      for(let key of Object.keys(time)){
        timeArr.push(time[key].replace(/,/g, ''))
      }
      return timeArr.join(',')
    }
  }
}
</script>
<style>
.visible-table-td tr td {
  overflow: visible;
}
.opt-table .time-picker-wrap thead tr {
  background: #fff;
}
.opt-table .time-picker-wrap thead th {
  border: 0;
}

</style>
<style scoped>
.fold-table .btn-icon{
  padding: 0 5px;
  vertical-align: baseline;
}
.advice-tip {
  margin-right: 20px;
  margin-top: 20px;
  line-height: 1em;
  margin-bottom: 20px;
}
.modal-bd-wrapper .modal-table-wrapper .advice-table{
  border: 1px solid #DADFE6;
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// service_advice_table.vue?c58cbece